// extracted by mini-css-extract-plugin
export var button = "_fl-2";
export var card = "_fl-0";
export var closeButtonContainer = "_fl-3";
export var iconContainer = "_fl-1";